/**
 * ヘッダーのドロップダウンメニュー（サブナビゲーション）の表示を制御するクラス
 */
export default class HeaderMenu {
  constructor() {
    this.navItems = document.querySelectorAll('[data-nav="parent-nav"]');
    this.subNavs = document.querySelectorAll('[data-js="child-nav"]');
    this.timeout = null;
    // デバイス判定の結果を保持
    this.isTouchDevice = this._checkTouchDevice();
  }

  /**
   * タッチデバイス（スマホ・タブレット）かどうかを判定
   * iPadOS対策として maxTouchPoints も確認する
   */
  _checkTouchDevice() {
    const ua = navigator.userAgent.toLowerCase();
    const isTablet =
      /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk)/g.test(
        ua
      );
    const isMobile = /iphone|ipod|android.*mobile|windows.*phone/g.test(ua);

    // iPad Proなどの「デスクトップ表示モード」対策
    const isIPadOS = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    return isTablet || isMobile || isIPadOS;
  }

  init() {
    if (this.navItems.length === 0) return;

    this.navItems.forEach((item) => {
      // --- PC用：ホバー操作 (タッチデバイスでない場合のみ有効にする) ---
      if (!this.isTouchDevice) {
        item.addEventListener('mouseenter', () => {
          clearTimeout(this.timeout);
          this._closeAll();
          this._open(item);
        });

        item.addEventListener('mouseleave', () => {
          this._close(item);
        });
      }

      // --- タブレット・スマホ用：クリック操作 ---
      const link = item.querySelector('a');
      link.addEventListener('click', (e) => {
        // タッチデバイス、かつ、まだメニューが開いていない場合
        if (this.isTouchDevice && !item.classList.contains('is-active')) {
          const subNav = item.querySelector('[data-js="child-nav"]');
          if (subNav) {
            e.preventDefault(); // リンク先への遷移をキャンセル
            this._closeAll();
            this._open(item);
          }
        }
      });
    });

    // メニュー以外をクリックしたら閉じる
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-nav="parent-nav"]')) {
        this._closeAll();
      }
    });
  }

  _closeAll() {
    this.navItems.forEach((item) => item.classList.remove('is-active'));
    this.subNavs.forEach((nav) => nav.classList.remove('is-active'));
  }

  _open(item) {
    item.classList.add('is-active');
    const subNav = item.querySelector('[data-js="child-nav"]');
    if (subNav) {
      subNav.classList.add('is-active');
    }
  }

  _close(item) {
    const subNav = item.querySelector('[data-js="child-nav"]');
    if (subNav) {
      this.timeout = setTimeout(() => {
        item.classList.remove('is-active'); // 親のクラスも外す
        subNav.classList.remove('is-active');
      }, 200);
    }
  }
}
